<template>
  <div class="about_us">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <div class="part1">
      <p class="title">公司简介</p>
      <p class="content">江苏道泰信息技术有限公司（{{website}}）成立于2021年7月，是一家专注于移动互联网商务服务领域，致力于为客户提供专业的数据资源整合、应用、开发和运营等方案与服务的高新技术企业，拥有高效的数据应用与服务平台的建设能力，支持客户在数据挖掘、数据整理、数据分析、精准营销、跨领域数据融合、供应链重组与整合等场景获得深度赋能。</p>
      <p class="content">公司作为一家数据科技企业，在保险金融领域的精准数据分析与挖掘方面拥有丰富的资源与技术积累，当前服务的客户主要包括众安保险经纪、爱邦保险经纪、保通保险代理等保险机构。</p>
      <p class="content">公司致力于为金融行业、公共事业等领域提供有竞争力的数据解决方案，不断提升客户体验，为客户创造最大价值，开启数据赋能的智慧科技新时代。</p>
    </div>

    <div class="part2">
      <p class="title">团队实力</p>
      <p class="content">公司管理人员来自于知名品牌企业，拥有科技、法律、管理等领域深厚的专业知识背景和丰富的从业经验，能够为行业客户提供优质的数据解决方案。</p>
      <p class="content">公司技术团队主要由数据技术、数据产品、算法挖掘、运营平台团队组成，目前约有40多位优秀的技术工程师加入，其中团队核心成员均达到十年以上基础数据研究经验，专注于大数据算法、数据模型及网络通信技术研究，专注于行业数据增值业务的探索与实践，致力于成为行业最佳数据解决方案供应商，让数据更智慧。</p>
    </div>

    <div class="part3">
      <p class="title">企业文化</p>
      <ul>
        <li v-for="item in part3">
          <img :src="item.imgUrl" />
          <div class="right_part">
            <p class="title">{{item.title}}</p>
            <p class="remark">{{item.remark1}}</p>
            <p class="remark">{{item.remark2}}</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="part4">
      <p class="title">团队文化建设</p>
      <div class="swiper">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img :src="teamImg1"/>
              <!-- <p>公司每年组织员工参与团建拓展活动</p> -->
            </div>
            <div class="swiper-slide">
              <img :src="teamImg2"/>
              <!-- <p>中秋节组织员工体能比赛幸运获奖队伍</p> -->
            </div>
            <div class="swiper-slide">
              <img :src="teamImg3"/>
              <!-- <p>公司年会盛大激动人心的现金抽奖活动</p> -->
            </div>
            <div class="swiper-slide">
              <img :src="teamImg4"/>
              <!-- <p>公司年会盛大激动人心的现金抽奖活动</p> -->
            </div>
            <div class="swiper-slide">
              <img :src="teamImg5"/>
              <!-- <p>公司年会盛大激动人心的现金抽奖活动</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/mComponents/Header"
  import Banners from "@/mComponents/Banners"
  import Footer from "@/mComponents/Footer"
  import Swiper from 'swiper/dist/js/swiper.js'

  export default {
    name: 'About_Us',
    data() {
      return {
        banner: require("@/assets/imgs/mobile/banner-04.png"),
        part3:[
          {imgUrl:require("@/assets/imgs/mobile/img-aboutus-01.png"),title:"保持自律",remark1:"成功的关键不是你执行的多完美",remark2:"而是你坚持的有多久"},
          {imgUrl:require("@/assets/imgs/mobile/img-aboutus-02.png"),title:"追求极致",remark1:"所有工作都是为了创造完美的产品",remark2:"创造让用户满意的完美产品"},
          {imgUrl:require("@/assets/imgs/mobile/img-aboutus-03.png"),title:"超越极限",remark1:"不断超越极限",remark2:"只有想不到，没有做不到"},
          ],
        teamImg1: require("@/assets/imgs/team-build-01.jpg"),
        teamImg2: require("@/assets/imgs/team-build-02.jpg"),
        teamImg3: require("@/assets/imgs/team-build-03.jpg"),
        teamImg4: require("@/assets/imgs/team-build-04.jpg"),
        teamImg5: require("@/assets/imgs/team-build-05.jpg"),
      }
    },
    components: {
      Header,Banners,Footer,
    },
    created() {
      this.$store.commit('changeNavsM', 'mAbout_Us')
    },
    methods: {
      noClick() {
        return false;
      }
    },
    mounted() {
      setTimeout(function() {
        $('img').on('click',function() {
          return false;
        })
        window.onscroll = function() {
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          if(scrollTop>30) {
            $(".icon-m-up").css("display","block")
            $(".top").addClass("active")
          } else {
            $(".icon-m-up").css("display","none")
            $(".top").removeClass("active")
          }
        }
      },100)
      var mySwiper = new Swiper('.about_us .swiper-container', {
        autoplay: true,
        loop: true,
        speed: 1000,
        pagination: '.swiper-pagination',
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 15,
        observer:true,
        observeParents:true
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss" type="text/scss">
  .about_us {
    background-color: #fff;

    .clear {
      clear: both;
    }
    .part1,.part2 {
      .title {
        font-size:0.4rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-bottom: 0.35rem;
      }
      .content {
        font-size:0.24rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:0.4rem;
      }
    }
    .part1 {
      background:rgba(237,237,237,1);
      padding: 0.4rem 0.4rem 0.6rem;
    }
    .part2 {
      padding: 0.6rem 0.4rem 0.8rem;
    }

    .part3 {
      background:rgba(237,237,237,1);
      padding: 0.6rem 0.7rem 1rem;
      >.title {
        font-size:0.4rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-bottom: 0.7rem;
      }
      ul {
        li {
          img {
            width: 2rem;
            height: 1.2rem;
            border-radius: 6px;
            display: inline-block;
          }
          .right_part {
            width: 3.8rem;
            display: inline-block;
            vertical-align: top;
            .title {
              font-size:0.3rem;
              line-height: 0.4rem;
              font-family:PingFangSC-Medium;
              font-weight:500;
              color:rgba(0,0,0,1);
              text-align: left;
              margin-bottom: 0.05rem;
            }
            .remark {
              font-size:0.24rem;
              line-height: 0.32rem;
              font-family:PingFangSC-Regular;
              font-weight:400;
              color:rgba(0,0,0,1);
              line-height:0.36rem;
              text-align: left;
            }
          }
        }
      }
    }

      .part4 {
        padding: 0.6rem 0 0.8rem;
        .title {
          font-size:0.32rem;
          font-family:PingFangSC-Medium;
          font-weight:500;
          color:rgba(0,0,0,1);
          text-align: center;
          margin-bottom: 0.6rem;
        }

        .swiper {
          .swiper-container {
            .swiper-slide {
              width: 6rem;
            }
            img {
              width: 6rem;
              border-radius: 15px;
              margin: 0 auto;
              display: block;
            }

            p {
              font-size:0.2rem;
              font-family:PingFangSC-Medium;
              font-weight:500;
              color:rgba(40,40,40,1);
              text-align: center;
              margin-top: 0.35rem;
            }
          }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Mobile/About_Us.vue